#import "../fragments/comparison-edition-fragment.graphql"
#import "../fragments/comparison-fragment.graphql"

mutation ToggleComparison($input: ComparisonToggleInput!) {
    comparisonToggle(input: $input) {
        edition {
            id
            name
            isABTesting
            comparison {
                ...ComparisonFragment
            }
            comparisonEdition {
                ...ComparisonEditionFragment
            }
        }
    }
}
